import React, { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Get } from "../Axios/AxiosFunctions";
import JobsCard from "../Components/JobsCard";
import { recordsLimit, URL } from "../Config/apiUrl";
import NullData from "../Components/NullData";
import { Col } from "react-bootstrap";
function AppliedJobs({ setfooterStyle }) {
  const history = useHistory();
  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  const user = useSelector((state) => state?.authReducer?.user);
  const token = useSelector((state) => state?.authReducer?.access_token);

  // ------------------------------------- states ------------------------------------
  const [jobsData, setJobsData] = useState([]);
  const [previousOffset, setPreviousOffset] = useState(0);
  const [hasMoreJobs, setHasMoreJobs] = useState(true);
  const [page, setPage] = useState(1);
  const [isLoadingMoreJobs, setIsLoadingMoreJobs] = useState(false);
  // ------------------------------------- handlers ------------------------------------
  const getJobs = async () => {
    if (isLoadingMoreJobs) return;
    if (page != 1 && previousOffset === jobsData.length) {
      setHasMoreJobs(false);
      return;
    }
    setPreviousOffset((p) => p + jobsData.length);

    const url = URL(
      `job/appliedJobs?id=${user?._id}&limit=${recordsLimit}&page=${page}`
    );

    setIsLoadingMoreJobs(true);
    const response = await Get(url, token);
    setIsLoadingMoreJobs(false);

    if (response != undefined) {
      setPage((p) => p + 1);
      // setPreviousOffset((p) => p + response?.data?.data?.length * 1);
      setHasMoreJobs(true);
      setJobsData((p) => [...p, ...response?.data?.data]);
    }
  };

  // on Load fire effect
  useEffect(() => {
    getJobs();
  }, []);

  return (
    <div className="container applied-jobs-container">
      {/* Map company jobs here :) */}
      {jobsData.length > 0 && (
        <InfiniteScroll
          className="company-jobs-container company-jobs-container-2"
          dataLength={jobsData.length}
          next={getJobs}
          hasMore={hasMoreJobs}
          // loader={isLoadingMoreJobs &&  <NullData />}
          // endMessage={
          //   <div className="msg_no_more_job" style={{ textAlign: "center" }}>
          //     <b>No More Jobs to show!</b>
          //   </div>
          // }
        >
          {jobsData.map((job, index) => (
            <Col md={4} className="appliedJobCardContainer">

            <JobsCard data={job} key={job?._id} col={12} />
            </Col>
          ))}
        </InfiniteScroll>
      )}
      {jobsData.length === 0 && !isLoadingMoreJobs && <p>No job found</p>}
      {isLoadingMoreJobs && <NullData />}
      {/* <NullData /> */}
    </div>
  );
}

export default AppliedJobs;
